//
// KeyValueDisplay.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../../lib";
import "../../core/GTLModel";

var KeyValueDisplay = createModule("gtl::KeyValueDisplay", ["commons::PropertyOwner","commons::BaseModel","gtl::GTLModel"], EventDispatcher, [
    ,
    {
        outline: 2,
        stat: 2,
        categorylabel: 2,
        fill: 2,
        responselabel: 2,
        responsevalue: 2,
        categoryvalue: 2,
    },
    ,
    ,
    ,
    {
        _create_v: [4],
        _create_s: [4,7],
        getValueFromString: [1,7,1],
        createSTANDARD: [1],
        createALL: [1],
        createNONE: [1],
    },
    ,
    ["_create"]
]);
export default KeyValueDisplay;
